export default {
  movesEntryStyles: {
    padding: "0.25rem 0 0.25rem 0",
  },
};
